// extracted by mini-css-extract-plugin
export default {"pocDetailInvitationCard":"poc-detail-invitation-card_pocDetailInvitationCard__xq8wL","invitationButton":"poc-detail-invitation-card_invitationButton__rFtgc"};